"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const react_1 = __importDefault(require("react"));
require("./banner.css");
/**
 * Main component.
 * @name banner
 * @param {BannerProps}
 * @returns {<Banner />}
*/
const Banner = ({ imageDesktopURL = "", imageMobileURL = "", logoURL = "", title = "", titleColor = "#ffffff", }) => {
    return (react_1.default.createElement("div", { className: "banner-container" },
        react_1.default.createElement("div", { className: "row " + imageMobileURL ? "d-none d-lg-flex" : "" },
            react_1.default.createElement("div", { className: "col-12", "data-testid": "banner-container" },
                react_1.default.createElement("div", { className: `row banner-desktop`, style: { backgroundImage: `url(${imageDesktopURL})` } },
                    react_1.default.createElement("div", { className: "banner-title d-none d-lg-flex col-lg-8", "data-testid": "banner-title" },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: `<span style="color:${titleColor};">${title}</span>` } })),
                    react_1.default.createElement("div", { className: "banner-icon d-none d-lg-flex col-lg-4", "data-testid": "banner-logo", style: { backgroundImage: `url(${logoURL})` } })))),
        imageMobileURL && (react_1.default.createElement("div", { "data-testid": "banner-container-mobile", style: { backgroundImage: `url(${imageMobileURL})` }, className: "banner-mobile d-lg-none" }))));
};
exports.Banner = Banner;
exports.default = exports.Banner;
//# sourceMappingURL=banner.js.map